import React, { Component } from 'react';

import FooterContent from 'components/customization/FooterContent';

class Footer extends Component {
  render() {
    return (
      <footer>
        <FooterContent />
      </footer>
    );
  }
}

Footer.propTypes = {};

export default Footer;



/** WEBPACK FOOTER **
 ** ./app/components/layout/Footer.js
 **/